
import CustomButton from "@/components/new/buttons/CustomButton.vue";
import { Vue, Component, Watch, Prop } from "vue-property-decorator";
import SchedulerViewSelect from "@/components/scheduler/schedulerSelects/SchedulerViewSelect.vue";
import DropdownFilter from "@/components/filters/DropdownFilter.vue";
import ProjectModalWithButton from "@/components/companyProjects/ProjectModalWithButton.vue";
import ProjectModal from "@/components/companyProjects/ProjectModal.vue";
import DropdownOption from "@/entities/DropdownOption";
import { Company, User } from "@/generated/graphql";
import UiButton from "../button/ui-button.vue";
import MultiSelectComponent from '@/components/MultiSelect.vue'

@Component({
  components: {
    CustomButton,
    DropdownFilter,
    SchedulerViewSelect,
    ProjectModalWithButton,
    ProjectModal,
    UiButton,
    MultiSelectComponent
  },
})
export default class TopFilterItem extends Vue {
  @Prop({ type: Array, default: () => [] }) value!: DropdownOption[];
  @Prop({ type: Boolean, default: true }) withBorder!: boolean;
  @Prop({ type: Boolean, default: false }) isAdmin!: boolean;
  @Prop({ type: Array, default: [] }) schedulerView!: any;
  @Prop({ type: Object, required: true }) readonly currentUser!: User;
  @Prop({ type: Object, required: true }) readonly company!: Company;
  @Prop({ type: String, default: "Select" }) readonly placeHolderText!: string;
  @Prop({ type: String, default: "" }) readonly filterClasses!: string;

  showAdditionalFilters: boolean = false;

  sidenav: boolean = true;
  selectedOption: DropdownOption[] = this.defaultOption;

  get defaultOption(): DropdownOption[] {

    return [{ name: "View by Clients", id: "view_by_projects" }];
    // if (!this.isAdmin) {
    //   return "View by Resources";
    // }
    // return "View by Managers";
  }

  options: any = [
    { name: "View by Clients", id: 'view_by_projects' },
    { name: "View by Resources", id: 'view_by_resources' },
    { name: "View by Managers", id: 'view_by_managers' },
  ];

  managerOptions: any = [{ name: "View by Clients", id: 'view_by_projects' },
  { name: "View by Resources", id: 'view_by_resources' }];

  dialog: boolean = false;

  toggle(): void {
    this.dialog = true;
  }

  get noCompany(): boolean {
    return !this.company.id;
  }
  optionChange(value: DropdownOption[]) {
    this.selectedOption = value;
    this.$emit("optionChange", value[0].name);
  }

  toggleAdditionalFilters(): void {
    this.showAdditionalFilters = !this.showAdditionalFilters;
    this.$emit("toggleAdditionalFilters", this.showAdditionalFilters);
  }
}
